import { OfficeListAdmin } from '../../../../components/Contact';

export function TBMContactOffices() {
  return <OfficeListAdmin />;
}
